import {
  CREATE_INSURANCENEED_START,
  CREATE_INSURANCENEED_SUCCESS,
  CREATE_INSURANCENEED_FAILURE,
  CREATE_INSURANCENEED_RESET,
  GET_INSURANCENEED_START,
  GET_INSURANCENEED_SUCCESS,
  GET_INSURANCENEED_FAILURE,
  GET_INSURANCENEED_RESET,
  GET_INCOME_START,
  GET_INCOME_SUCCESS,
  GET_INCOME_FAILURE,
  GET_INCOME_RESET,
  DELETE_INSURANCE_NEED_START,
  DELETE_INSURANCE_NEED_FAILURE,
  DELETE_INSURANCE_NEED_RESET,
  DELETE_INSURANCE_NEED_SUCCESS,
  UPDATE_INSURANCE_NEED,
  UPDATE_INSURANCE_NEED_SUCCESS,
  UPDATE_INSURANCE_NEED_FAILED

} from "./actiontypes"


export const createInsuranceNeedStart = payload => {
  return {
    type: CREATE_INSURANCENEED_START,
    payload,
  }
}

export const createInsuranceNeedSuccess = payload => {
  return {
    type: CREATE_INSURANCENEED_SUCCESS,
    payload,
  }
}

export const createInsuranceNeedFailure = error => {
  return {
    type: CREATE_INSURANCENEED_FAILURE,
    error,
  }
}
export const createInsuranceNeedReset = () => {
  return {
    type: CREATE_INSURANCENEED_RESET,
  }
}



export const getInsuranceNeedStart = (payload) => {
  return {
    type: GET_INSURANCENEED_START,
    payload
  }
}

export const getInsuranceNeedSuccess = (payload) => {
  return {
    type: GET_INSURANCENEED_SUCCESS,
    payload,
  }
}

export const getInsuranceNeedFailure = error => {
  return {
    type: GET_INSURANCENEED_FAILURE,
    payload: error,
  }
}
export const getInsuranceNeedReset = () => {
  return {
    type: GET_INSURANCENEED_RESET,
  }
}



export const getIncomeStart = () => {
  return {
    type: GET_INCOME_START,
  }
}

export const getIncomeSuccess = (payload) => {
  return {
    type: GET_INCOME_SUCCESS,
    payload,
  }
}

export const getIncomeFailure = error => {
  return {
    type: GET_INCOME_FAILURE,
    error,
  }
}
export const getIncomeReset = () => {
  return {
    type: GET_INCOME_RESET,
  }
}


// DELETE INSURANCE NEED START :
export const deleteInsuranceNeedStart = (payload) => {
  return {
    type: DELETE_INSURANCE_NEED_START,
    payload
  }
}

export const deleteInsuranceNeedSuccess = (payload) => {
  return {
    type: DELETE_INSURANCE_NEED_SUCCESS,
    payload,
  }
}

export const deleteInsuranceNeedFailure = error => {
  return {
    type: DELETE_INSURANCE_NEED_FAILURE,
    payload: error,
  }
}
export const deleteInsuranceNeedReset = () => {
  return {
    type: DELETE_INSURANCE_NEED_RESET,
  }
}


export const updateInsuranceNeed = (payload) => {
  return {
    type: UPDATE_INSURANCE_NEED,
    payload
  }
}

export const updateInsuranceNeedSuccess = (payload) => {
  return {
    type: UPDATE_INSURANCE_NEED_SUCCESS,
    payload
  }
}

export const updateInsuranceNeedFailed = (payload) => {
  return {
    type: UPDATE_INSURANCE_NEED_FAILED,
    payload
  }
}